import { Component, JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { Dialog } from "../Dialog/Dialog";
import { DialogContent } from "../Dialog/DialogContent";
import { DialogFooter } from "../Dialog/DialogFooter";
import { Card } from "../../Cards/Card/Card";
import { GridContainer } from "../../Layout/Grid/GridContainer";
import { GridItem } from "../../Layout/Grid/GridItem";
import { ButtonBar } from "../../Buttons/ButtonBar/ButtonBar";
import { RightButtons } from "../../Buttons/ButtonBar/RightButtons";
import { Button } from "../../Buttons/Button/Button";

export class AlertDialog extends BaseComponent<IAlertDialogProps, IAlertDialogState>
{
    public static okButtonLabel = '';

    public render(): JSX.Element
    {
        const props = this.props;
        const showModal = (props.show && !!props.message);
        const isHtml = props.options?.messageIsHtml ?? false;

        return (
            <>
                <Dialog
                    isOpen={showModal}
                    onOpenChange={() => props.onClose()}
                    lg={5}
                    zIndex={10000}
                >
                    <DialogContent>
                        <Card
                            title={props.title}
                            details={!isHtml ? props.message : ''}
                        >
                            {
                                isHtml &&
                                <GridContainer>
                                    <GridItem>
                                        <span dangerouslySetInnerHTML={{ __html: props.message }}></span>
                                    </GridItem>
                                </GridContainer>
                            }
                        </Card>
                    </DialogContent>
                    <DialogFooter>
                        <ButtonBar>
                            <RightButtons>
                                <Button
                                    styleType='filled'
                                    onClick={() => props.onClose()}
                                >
                                    {this.props.okButtonLabel ?? AlertDialog.okButtonLabel}
                                </Button>
                            </RightButtons>
                        </ButtonBar>
                    </DialogFooter>
                </Dialog>
            </>
        );
    }
}

export class AlertDialogController
{
    public changed?: ((show: boolean, title: string, message: string, options?: IAlertDialogOptions) => Promise<void>);
    private onClose?: () => void;

    public show(title: string, message: string, onClose?: () => void, options?: IAlertDialogOptions): Promise<void>
    {
        if (!message || !this.changed)
        {
            return Promise.resolve();
        }
        this.onClose = onClose;
        return this.changed(true, title, message, options);
    }

    public async hide(): Promise<void>
    {
        try
        {
            if (!this.changed)
            {
                return Promise.resolve();
            }

            await this.changed(false, "", "");
            if (this.onClose)
            {
                this.onClose();
            }
        }
        finally
        {
            this.onClose = undefined;
        }
    }
}

export interface IAlertDialogProps
{
    okButtonLabel?: string;
    show: boolean;
    title: string;
    message: string;
    options?: IAlertDialogOptions
    onClose: () => void;
}

export interface IAlertDialogOptions
{
    messageIsHtml?: boolean;
}

export interface IAlertDialogState { }
